import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollSmoother } from 'gsap/ScrollSmoother.js';

export default class Scroller {
  constructor(element) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollSmoother);
    this.options = {
      hasSkew: false,
      hasScale: false,
      hasPinItems: false,
    };
    this.element = element;

    this.links = document.querySelectorAll('.js-anchor-link');
    this.setOptions();
    this.init();
  }
  init() {
    this.scroller = ScrollSmoother.create({
      smooth: 2,
      effects: true,
      smoothTouch: 0.1,
      onUpdate: this.onUpdateScroll.bind(this),
      onStop: this.onStopScroll.bind(this),
      ease: 'expo.out',
    });

    for (let i = 0; i < this.links.length; i++) {
      const link = this.links[i];
      link.addEventListener('click', this.scrollTo.bind(this));
    }
  }

  // Skew

  initSkew() {
    this.skewSetter = gsap.quickTo('img', 'skewY');
  }
  updateSkew(self) {
    const velocity = self.getVelocity();
    const force = 5;
    let skew = gsap.utils.mapRange(-1000, 1000, -force, force, velocity);
    skew = gsap.utils.clamp(-force, force, skew);
    this.skewSetter(skew);
  }
  stopSkew() {
    this.skewSetter(0);
  }

  // Scale

  initScale() {
    this.scaleSetter = gsap.quickTo('img', 'scaleY');
  }
  updateScale(self) {
    const velocity = self.getVelocity();
    const force = 0.2;
    let scale = gsap.utils.mapRange(
      -1000,
      1000,
      1 - force,
      1 + force,
      velocity,
    );
    scale = gsap.utils.clamp(1 - force, 1 + force, scale);
    this.scaleSetter(scale);
  }
  stopScale() {
    this.scaleSetter(1);
  }

  // Scroll

  onUpdateScroll(self) {
    if (this.options.hasSkew) this.updateSkew(self);
    if (this.options.hasScale) this.updateScale(self);
  }

  onStopScroll(self) {
    if (this.options.hasSkew) this.stopSkew(self);
    if (this.options.hasScale) this.stopScale(self);
  }

  // Pins

  initPins() {
    const pinnedItems = document.querySelectorAll('.js-pinned');
    for (let i = 0; i < pinnedItems.length; i++) {
      const pinnedItem = pinnedItems[i];

      ScrollTrigger.create({
        pin: pinnedItem,
        trigger: pinnedItem.parentElement,
        start: '-2.5% top',
        end: '90% bottom',
      });
    }
  }

  // Horizontal

  initHoriz() {
    const sections = this.element.querySelectorAll('.js-horiz');
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const panels = section.querySelectorAll('.js-panel');
      const nbPanel = panels.length - 1;
      const buffer = 200;

      gsap.to(panels, {
        xPercent: -100 * nbPanel,
        ease: 'none',
        scrollTrigger: {
          pin: true,
          trigger: section,
          scrub: true,
          snap: 1 / nbPanel,
          end: () => '+=' + (section.offsetWidth + buffer),
        },
      });
    }
  }

  scrollTo(event) {
    const target = event.currentTarget;
    console.log('#' + target.dataset.scrollId);
    if (
      'scrollId' in target.dataset &&
      document.querySelector('#' + target.dataset.scrollId)
    ) {
      this.scroller.scrollTo(
        document.querySelector('#' + target.dataset.scrollId),
        true,
        'top 0',
      );
      document.documentElement.classList.remove('nav-is-active');
    }
  }

  setOptions() {
    if ('skew' in this.element.dataset) {
      this.options.hasSkew = true;
      this.initSkew();
    }
    if ('scale' in this.element.dataset) {
      this.options.hasScale = true;
      this.initScale();
    }
    if ('pinItems' in this.element.dataset) {
      this.options.hasPinItems = true;
      this.initPins();
    }
    if (this.element.querySelector('.js-horiz')) {
      this.initHoriz();
    }
  }
}
